import React from "react";
import { useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch } from "react-redux";
import { format } from 'date-fns';
import {
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Typography,
} from "@material-ui/core";

import { getArchivosAdjuntos } from "../../redux/selectors";
import styles from "./styles.styles";
import { eliminarArchivo } from "../../redux/actions/tablaActions";

export default () => {
  const classes = styles();
  const archivos = useSelector((state) => getArchivosAdjuntos(state));
  const dispatch = useDispatch();

  const deleteFile = (archivoAEliminar : File) => {
    dispatch(eliminarArchivo(archivoAEliminar));
  };

  const mostrarArchivos = () => {
    return archivos.map((archivo : File) => (
      <TableRow key={archivo.name}>
      <TableCell className={classes.celdaFecha}>{format(new Date(),'dd/MM/yyyy')}</TableCell>
      <TableCell className={classes.celdaTabla}>{archivo.name}</TableCell>
        <TableCell className={classes.botonBorrar} align='right'>
          <DeleteIcon color="primary" onClick={(e) => deleteFile(archivo)}>
            Eliminar
          </DeleteIcon>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <Container disableGutters={true}>
      <Typography
        color="primary"
        className={classes.tableTitle}
        style={
          archivos.length === 0 ? { display: "none" } : { display: "flex" }
        }
      >
        Archivos para subir
      </Typography>
      <TableContainer>
        <Table aria-label="tabla adjuntos" padding="default">
          <TableBody>{mostrarArchivos()}</TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};
